import { Button, Col, Input, Modal, Row, Select, Spin } from 'antd';
import Title from 'antd/es/typography/Title';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getAlignObjectiveKr } from 'app/entities/common/common.reducer';
import { setFilterRowSelectionObjKr } from 'app/entities/filters/filters.reducer';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import TableComponent from 'app/shared/component/table/table';
import { OrderByType } from 'app/shared/model/enum/order-type.enum';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { filterOption } from 'app/shared/util/select-filter';
import * as _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';
import { columns, versionPlanPeriodYear } from './config';

const { Search } = Input;

type IRepresentatives = {
  isOpen: boolean;
  defaultSelected: any[];
  onClose: (isUpdate: boolean, itemSelected?: any[]) => void;
};

export const ObjectiveKRRowSelection = ({ isOpen, onClose, defaultSelected }: IRepresentatives) => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const filterActivities = useAppSelector(state => state.filters.activities);
  const filters = useAppSelector(state => state.filters.rowSelectionObjKr);
  const planPeriodList = useAppSelector(state => state.planPeriod.entities);
  const alignObjKrList = useAppSelector(state => state.common.alignObjKr);
  const isLoading = useAppSelector(state => state.common.loadingAlign);

  const [selectedItem, setSelectedItem] = useState<any[]>();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  useEffect(() => {
    dispatch(getPlanPeriods({}));
  }, [])

  useEffect(() => {
    getAllEntities();
  }, [paginationState.activePage, paginationState.itemsPerPage, paginationState.sort, filters]);

  const getAllEntities = () => {
    dispatch(
      getAlignObjectiveKr({
        searchText: filters?.searchText,
        page: filters?.searchText ? paginationState.activePage : 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        planPeriodId: filters?.planPeriodId,
        partyId: filterActivities?.accountableId,
        okrVersion: filters?.okrVersion
      }),
    );
  };

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    const { order, sort } = paginationState;
    setPaginationState({
      ...paginationState,
      order: Object.keys(sorter).length !== 0 ? (sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC) : order,
      sort: Object.keys(sorter).length !== 0 ? sorter.columnKey : sort,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleFreeTextSearchQuery = query => {
    dispatch(
      setFilterRowSelectionObjKr({
        ...filters,
        searchText: query,
      }),
    );
  };

  const rowSelection = {
    type: 'radio',
    // eslint-disable-next-line @typescript-eslint/no-shadow
    onChange(selectedRowKeys: React.Key[], selectedRows: any[]) {
      setSelectedItem(selectedRows)
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.objectType === 1,
    }),
    // Disable selection for children rows when parent has objectType = 1
    onSelect: (record: any, selected: boolean, selectedRows: any[], nativeEvent: Event) => {
      // Prevent selection if objectType is 1
      if (record.objectType === 1) {
        return false;
      }
    },
  };

  const handleClose = () => {
    onClose(false);
  };

  const handleConfirm = () => {
    onClose(true, selectedItem);
  };

  const handleChangePlanPeriod = (value: string) => {
    const detailPlanPeriod = _.find(planPeriodList, o => o.id === value);
    if (detailPlanPeriod) {
      // if (detailPlanPeriod.planPeriodType === PlantPeriodType.Month) {
      //   dispatch(getByMonth(detailPlanPeriod.month))
      // }
      dispatch(
        setFilterRowSelectionObjKr({
          ...filters,
          reportScheduleId: null,
          planPeriodId: value,
          planPeriodType: detailPlanPeriod.planPeriodType,
        }),
      );
    }
  };

  const handleChangeAdjustPlanPeriods = value => {
    dispatch(
      setFilterRowSelectionObjKr({
        ...filters,
        okrVersion: value,
      }),
    );
  };

  const handleChangeReportSchedule = value => {
    dispatch(
      setFilterRowSelectionObjKr({
        ...filters,
        reportScheduleId: value,
      }),
    );
  };

  return (
    <Modal
      open={isOpen}
      maskClosable={false}
      onCancel={() => {
        handleClose();
      }}
      footer={<Row className="d-flex action mt-3" justify="end">
        <Col>
          <Button size='large' className="primary" onClick={handleConfirm}>
            Chọn
          </Button>
        </Col>
        <Col>
          <Button
            className="secondary"
            onClick={() => {
              handleClose();
            }}
            size='large'
          >
            Hủy
          </Button>
        </Col>
      </Row>}
      width={1300}
    >
      <Spin spinning={isLoading} delay={300}>
        <Container className="view">
          <Title level={3}>{`Chọn MT/KR cần liên kết với công việc ${filterActivities?.accountableName ? `- ${filterActivities?.accountableName}` : ''}`}</Title>
          <div className="table">
            <div className="header">
              <Col md={24}>
                <Row className='w-100'>
                  <Col md={4}>
                    <Select
                      className="w-100"
                      value={filters?.planPeriodId}
                      showSearch
                      options={planPeriodList.map(x => {
                        return {
                          value: x.id,
                          label: x.name,
                        };
                      })}
                      onChange={handleChangePlanPeriod}
                      filterOption={filterOption}
                      placeholder="Chọn kỳ kế hoạch"
                      size="large"
                    />
                  </Col>
                  {filters?.planPeriodType === PlantPeriodType.Year && (
                    <>
                      <Col md={1} />
                      <Col md={5}>
                        <Select
                          className="w-100"
                          value={filters?.okrVersion}
                          options={versionPlanPeriodYear}
                          onChange={handleChangeAdjustPlanPeriods}
                          filterOption={filterOption}
                          placeholder="Chọn phiên bản"
                          size="large"
                        />
                      </Col>
                    </>
                  )}
                  {/* {filters?.planPeriodType === PlantPeriodType.Month && (
                    <>
                      <Col md={1} />
                      <Col md={5}>
                        <Select
                          className="w-100"
                          value={filters?.reportScheduleId}
                          options={reportSchedules}
                          onChange={handleChangeReportSchedule}
                          filterOption={filterOption}
                          placeholder="Chọn kỳ báo cáo"
                          size="large"
                        />
                      </Col>
                    </>
                  )} */}
                  <Col md={1} />
                  <Col md={11}>
                    <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                  </Col>
                </Row>
              </Col>
            </div>

            <TableComponent
              rowSelection={rowSelection}
              data={alignObjKrList.map(x => {
                return {
                  ...x,
                  key: x.id,
                  children: x.krSubSets.length > 0 && x.krSubSets.map(y => {
                    return {
                      key: y.id,
                      ...y
                    }
                  })
                }
              })}
              noPagination={true}
              total={0}
              expandedRowKeys={expandedRowKeys}
              setExpandedRowKeys={setExpandedRowKeys}
              isFetching={false}
              scroll={true}
              columns={columns}
              handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
                handleChange(pageNumber, size, sorter);
              }}
            />
          </div>
        </Container>
      </Spin>
    </Modal>
  );
};

export default ObjectiveKRRowSelection;
